import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from '../base';
import { WooCommerceSalesOrder, WooCommerceSalesOrderLineItems } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class WooCommerceService extends TmsWebBaseService {
  constructor() {
    super('WooCommerce');
  }

  getSalesOrderLines(id: string): Observable<WooCommerceSalesOrderLineItems[]> {
    return this.httpService.get<WooCommerceSalesOrderLineItems[]>(`${this.apiUrl}/GetSalesOrderLines?id=${id}`);
  }

  importSalesOrders(
    search: string,
    allStock: boolean,
    needAttention: boolean,
    importOrders: boolean,
  ): Observable<WooCommerceSalesOrder[]> {
    return this.httpService.post<WooCommerceSalesOrder[]>(`${this.apiUrl}/ImportSalesOrders`, {
      search,
      allStock,
      needAttention,
      importOrders,
    });
  }
}
